import { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { VStack, HStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import LoaderIndicator from "../components/loader_indicator";

import TableData from "../components/mops_page/table_data";
import FiltersGrid from "../components/mops_page/filters_grid";


const MopsPage = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.getAllManagers();
    pageStore.getAllDepartments();
    pageStore.getAllBackups();
    pageStore.resetFilters();
  }, []);

  useEffect(() => {
    pageStore.updateSelectedPeriod("");
  }, []);

  useEffect(() => {
    pageStore.updateSelectedPage("/mops");
  }, []);

  console.log("email", pageStore.email);

  return (
    <VStack width={"100%"} align={"flex-start"}>

      <HStack
        width="100%"
        spacing="15px"
        wrap="wrap"
        padding="0 20px"
        marginTop="20px"
        justify="center"
      >
        <FiltersGrid
          page="payments"
          renderButtons={(buttons) => buttons}
        />
        <TableData data={pageStore?.data_mops} renderButtons={(buttons) => buttons}/>
        </HStack>
    </VStack>
  );
});

export default MopsPage;
